var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ChartsFilter',{attrs:{"area-options":_vm.areaList,"category-options":_vm.cateList,"name-options":_vm.nameList},on:{"search":_vm.handleSearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }